import Image from "next/image";
import Link from "next/link";
import Profile from '@/assets/icons/common/avatar.svg';

export default function AuthorBio({ userData }: any) {
  const author = userData?.updated_by_user ?? userData?.created_by_user;

  if (!author) return null;

  const authorName = author.name ?? "Tanny Verma";
  const authorImage = author.profile_picture?.url ?? Profile;
  const authorTitle = author.designation ?? "Content Writer";
  const authorBio = author.author_bio ?? "";
  const authorId = author.id;

  // Generate slug: lowercase, remove spaces and special characters
  const cleanName = authorName.toLowerCase().replace(/[^a-z0-9]/gi, '');
  const authorUrl = authorId ? `/authors/${cleanName}${authorId}` : null;

  return (
    <div className="mt-8 rounded-md border border-gray-200 bg-white p-6 shadow-md">
      <h2 className="mb-4 text-xl font-bold">About the Author</h2>
      <div className="flex items-start">
        <div className="mr-4 shrink-0">
          <img
            src={authorImage}
            alt={authorName}
            className="size-12 rounded-full object-cover"
          />
        </div>
        <div>
          {authorUrl ? (
            <Link
              href={authorUrl}
              className="text-lg font-semibold text-blue-600 hover:underline"
            >
              {authorName}
            </Link>
          ) : (
            <h3 className="text-lg font-semibold">{authorName}</h3>
          )}

          {authorTitle && (
            <p className="mb-1 text-sm text-gray-600">{authorTitle}</p>
          )}

          {authorBio && (
            <p className="text-gray-700">
              {authorBio}
              {authorUrl && (
                <Link
                  href={authorUrl}
                  className="ml-1 text-blue-600 hover:underline"
                >
                  Read More
                </Link>
              )}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
